import { RegItem } from 'src/types/regItem'
import { MeterProps } from 'baby-design/components/Meter/Meter.types'

export const handleContributeClick = (regItem: RegItem) => {
  console.log(`Contribute clicked for regItem ${regItem.id}`)
}

export const meterPropsFrom = (regItem: RegItem): MeterProps => {
  const { fundedAmount, goalAmount } = regItem

  let groupGiftProgress = 0
  let stillNeeds = goalAmount

  if (fundedAmount && goalAmount) {
    groupGiftProgress = (fundedAmount / goalAmount) * 100
    stillNeeds = goalAmount - fundedAmount
  }

  return {
    label: `Still needs $${stillNeeds.toFixed(2)}`,
    percentage: groupGiftProgress,
    size: 'sm',
  }
}
